<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('afterSales.search_document.title') }}
      </h2>

      <div class="irinox-form after-sales p-mt-4" >
        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6 p-xl-3">
                  <label for="category">{{ $t('afterSales.search_document.category') }}</label>
                  <Dropdown id="category"
                      v-model="filters.category"
                      :options="categories"
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('afterSales.search_document.category_ph')"  />
              </div>
              <div class="p-field p-col-12 p-md-6 p-xl-3">
                  <label for="title" >{{ $t('afterSales.search_document.title_doc') }}</label>
                  <InputText id="title" v-model="filters.title" :placeholder="$t('afterSales.search_document.title_doc_ph')" 
                    />
              </div>
              <div class="p-field p-col-12 p-md-6 p-xl-3">
                  <label for="lang">{{ $t('afterSales.search_document.lang') }}</label>
                  <Dropdown id="lang"
                      v-model="filters.language"
                      :options="languages"
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('afterSales.search_document.lang_ph')" >
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="p-d-flex p-ai-center">
                              <img v-if="slotProps.value!='MULTI'" :alt="slotProps.value.label" src="assets/demo/flags/flag_placeholder.png" :class="`p-mr-2 flag flag-${langs[slotProps.value].flag}`" style="width: 18px" />
                              <div>{{ langs[slotProps.value].name }}</div>
                          </div>
                          <span v-else>
                              {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="p-d-flex p-ai-center">
                              <img v-if="slotProps.option.value!='MULTI'" :alt="slotProps.option.label" src="assets/demo/flags/flag_placeholder.png" :class="`p-mr-2 flag flag-${langs[slotProps.option.value].flag}`" style="width: 18px" />
                              <div>{{ slotProps.option.label }}</div>
                          </div>
                      </template>
                  </Dropdown>
              </div>
              <div class="p-field p-col-12 p-md-6 p-xl-3">
                  <label for="model" >{{ $t('afterSales.search_document.model') }}</label>
                  <InputText id="model" v-model="filters.model" :placeholder="$t('afterSales.search_document.model_ph')" 
                    />
              </div>
              <div class="p-col-12 p-d-flex p-ai-center p-jc-center p-mt-3 p-mb-6" style="gap: 10px;">
                  <Button :label="$t('afterSales.search_document.btn_search')" class="" @click="newSearch" style="width: fit-content;"/>
                  <Button :label="$t('afterSales.search_document.btn_reset')" class="p-button-outlined" @click="resetFilters" style="width: fit-content;"/>
              </div>
          </div>
          
          <div v-if="submitted">
            <DataTable :value="documents" stripedRows 
                class="after-sales-table-full"
                responsiveLayout="stack" 
                breakpoint="960px" dataKey="documentId"
                :autoLayout="true" sortField="documentId" :sortOrder="1"
                :paginator="true" paginatorPosition="bottom" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" 
                v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords" :lazy="true"
                @update:first="searchDocs" 
                :currentPageReportTemplate="'{totalRecords} ' + $t('afterSales.search_document.counter')">

                

                <Column field="docTreeIds" :header="$t('afterSales.search_document.col_model')">
                  <template #body="slotProps">
                    <span v-html="getModelName(slotProps.data.docTreeIds)"></span>
                  </template>
                </Column>

                <Column field="title" :header="$t('afterSales.search_document.col_title')"></Column>

                <Column field="category" :header="$t('afterSales.search_document.col_category')">
                  <template #body="slotProps">
                    {{ $t(`afterSales.category.${slotProps.data.category}`) }}
                  </template>
                </Column>

                <Column field="language" :header="$t('afterSales.search_document.col_language')">
                  <template #body="slotProps">
                    <div class="p-d-flex p-ai-center" style="gap: 10px;">
                      <img v-if="langs[slotProps.data.lang]?.flag" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + langs[slotProps.data.lang].flag" width="30" :alt="slotProps.data.lang"/>
                      <div v-if="slotProps.data.lang=='MULTI'" style="width: 110px">{{ $t('afterSales.lang_MULTI')}}</div>
                      <div v-else style="width: 70px">{{ slotProps.data.lang }}</div>
                    </div>
                  </template>
                </Column>

                <Column v-if="role==='INTERNAL_DOC' || role.includes('FACTORY')" field="access" :header="$t('afterSales.search_document.col_access')">
                  <template #body="slotProps">
                    <div>{{ slotProps.data.access }}</div>
                  </template>
                </Column>

                <Column v-if="role==='INTERNAL_DOC' || role.includes('FACTORY')" field="distributions" :header="$t('afterSales.search_document.col_distributions')">
                  <template #body="slotProps">
                    <div v-for="distribution in slotProps.data.distributions.sort()" :key="distribution">
                      {{ distribution }}
                    </div>
                  </template>
                </Column>

                <Column>
                  <template #body="slotProps">
                    <div class="p-d-flex p-ai-center after-sales-datatable-buttons p-jc-end" style="font-size: 25px; gap: 20px;">

                      <i v-if="slotProps.data.type === 'FILE'" :class="['pi', $functions.documentIcon(slotProps.data.externalRef)]" @click="openDocument(slotProps.data)"/>
                      <i v-else :class="['pi', $functions.linkIcon(slotProps.data.externalRef)]"  @click="openDocument(slotProps.data)"/>

                      <i v-if="role==='INTERNAL_DOC' || role==='SUPERFACTORY'" class="icon-edit" @click="updateDialog(slotProps.data)" style="color: #808080;"/>

                      <i v-if="role==='INTERNAL_DOC' || role==='SUPERFACTORY'" class="icon-trash" @click="deleteDocument(slotProps.data)" style="color: #A70008;"/>

                    </div>
                  </template>
                </Column>


            </DataTable>


          </div>
      </div>



    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('afterSales.search_document.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  <Dialog :visible="dialog.deleteConfirm" class="irinox-dialog-dark" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '580px'}" :draggable="false">
    
    <div class="irinox-dialog-dark-content">
      <img src="/assets/irinox/icons/delete_big.svg" width="80"  :alt="$t('common.confirm')"/>
      <div class="p-pt-3 p-pb-1" style="line-height: 35px;">{{ $t('afterSales.search_document.delete_document_confirm') }}</div>
      <div class="p-pt-2 p-pb-3 p-d-flex p-ai-center p-text-left" style="font-size: 20px; line-height: 20px;">
        <Checkbox inputId="deleteAll" v-model="del.flag" binary="true"/>
        <label for="deleteAll" class="p-ml-2">{{ $t('afterSales.search_document.delete_document_all') }}</label>
      </div>

      <Button :label="$t('afterSales.search_document.delete_document_cancel')" @click="dialog.deleteConfirm = false;"/>
      <Button :label="$t('afterSales.search_document.delete_document_delete')" class="p-button-secondary" @click="deleteDocumentConfirmed"/>
    </div>

    <template #footer>
    </template>
  </Dialog>
  
  <IrinoxDialogDark :visible="dialog.deleteError" 
    mode="error" 
    :message="$t('afterSales.search_document.delete_document_error')"
    :life="3000" 
    @update:visible="dialog.deleteError = $event" />
  <IrinoxDialogDark :visible="dialog.deleteSuccess" 
    mode="success" 
    :message="$t('afterSales.search_document.delete_document_success')"
    :life="3000" 
    @update:visible="dialog.deleteSuccess = $event" />

  <SearchDocumentEdit
    :visible="dialog.editDocument"
    :documentId="edit.documentId"
    :title="edit.title"
    :access="edit.access"
    :distributions="edit.distributions"
    @update:visible="dialog.editDocument = $event" 
    @saved:document="documentSaved"/>

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import SearchDocumentEdit from './SearchDocumentEdit.vue';
import AfterSalesService from '../../service/AfterSalesService';

export default {
  components: { 
    IrinoxDialogDark,
    SearchDocumentEdit
  },
  data() {
    return {
      filters: { 
        model: null, 
        category: null,
        title: null,
        language: null
      },
      categories: [],
      langs: this.$functions.documentLanguages(),
      submitted: false,
      dialog: {
        error: false,
        deleteConfirm: false,
        deleteError: false,
        editDocument: false,
      },
      documents: [],
      table: {
        rows: 50,
        totalRecords: 0,
        first: 0
      },
      del: {
        doc: null,
        flag: false
      },
      edit: {
        documentId: null,
        title: null,
        access: null,
        distributions: []
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      searchDocument: 'afterSales/searchDocument',
      role: 'userdata/role',
    }),
    languages() {
      let temp = [];
      for(let l in this.langs) {
        temp.push({ label: this.langs[l].name, value: l });
      }
      return temp;
    },
    modelsLeaf: function() {
      // get the last 2 levels of the docTreeRaw
      let models = {};
      for(let m of this.docTreeRaw) {
        for(let lev=5; lev>=2; lev--) {
          if(m['level'+lev]) {
            let label = (m['level'+(lev-1)+'Translation'] ?? m['level'+(lev-1)]) + ' - ' + (m['level'+lev+'Translation'] ?? m['level'+lev]);
            if(m.domain!='STANDARD') {
              label = '[' + m.domain + '] ' + label;
            }
            models['DOCTREE_' + m.docTreeId] = {data: m, label: label};
            break;
          }
        }
      }
      return models;
    },
    models: function() {
      // get the last 2 levels of the docTreeRaw
      let models = {};
      for(let m of this.docTreeRaw) {
        let labelParts = [];
        for(let lev=1; lev<=5; lev++) {
          if(m['level'+lev]) {
            labelParts.push(m['level'+lev+'Translation'] ?? m['level'+lev]);
          }
        }
        let label = labelParts.join(' - ');
        if(m.domain!='STANDARD') {
          label = '[' + m.domain + '] ' + label;
        }
        models['DOCTREE_' + m.docTreeId] = {data: m, label: label};
      }
      return models;
    },
  },
  watch: {
  },
  created() {
    this.afterSalesService = new AfterSalesService();
    delete this.langs.MULTI; // remove MULTI from langs
  },
  mounted() { 
    if(this.docTreeRaw.length===0) {
      this.$router.push('/after-sales');
    }
    this.filters.model = this.searchDocument?.model;
    this.filters.category = this.searchDocument?.category;
    this.filters.title = this.searchDocument?.title;
    this.filters.language = this.searchDocument?.language;
    this.getCategories();
  },
  unmounted() {
    this.$store.commit('afterSales/searchDocument', {model: this.filters.model, category: this.filters.category, title: this.filters.title, language: this.filters.language});
  },
  methods: {
    getCategories() {
      this.categories = [];
      this.afterSalesService.getCategories(this.personaltoken)
        .then((data) => {
          if(data.code==="200" && data.body) {
            data.body.forEach(cat => {
              this.categories.push({ label: this.$t('afterSales.category.'+cat), value: cat });
            });
            this.categories.sort((a,b) => (a.label>b.label) ? 1 : ((b.label>a.label) ? -1 : 0));
          } else {
            console.error("ERROR "+JSON.stringify(data));
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
        });
    },
    resetFilters() {
      this.filters = { 
        model: null, 
        category: null,
        title: null,
        language: null
      };
      this.documents = [];
      this.table.totalRecords = 0;
      this.table.first = 0;
      this.submitted = false;
    },
    newSearch() {
      this.table.first = 0;
      this.searchDocs();
    },
    searchDocs() {
      this.documents = [];
      this.table.totalRecords = 0;
      this.submitted = true;
      this.afterSalesService.searchDocuments(this.personaltoken, this.filters, this.table)
        .then((data) => {
          if(data.code=="200") {
            this.documents = data.body.items;
            this.table.totalRecords = data.body.count;
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.error = true;
        });
    },
    getModelName(docTreeIds) {
      return docTreeIds
            .filter(id => this.models['DOCTREE_' + id]?.label)
            // .map(id => '<a href="#/after-sales/tree/'+id+'">' + this.models['DOCTREE_' + id]?.label ?? id + '</a>')
            .map(id => this.models['DOCTREE_' + id]?.label ?? id)
            .sort()
            .join('<br/>');
    },
    openDocument(doc) {
      // Logic to open the document
      this.afterSalesService.docAuditLog(this.personaltoken, doc.documentId).catch(error => { console.error("AUDIT EXCEPTION "+error); });
      if(doc.type === 'FILE') {
        this.download(doc);
      } else if(doc.type === 'LINK' && doc.externalRef) {
        window.open(doc.externalRef, '_blank');
      }
    },
    download(doc) {
        this.afterSalesService.downloadDocument(doc.externalRef)
          .then((res) => {
            let contentType = res.headers["content-type"];
            if(contentType !== 'application/json') {
              let filename = doc.title;
              try {
                const url = new URL(doc.externalRef);
                const decodedPath = decodeURIComponent(url.pathname);
                const parts = decodedPath.split('/');
                const last = parts[parts.length - 1];
                if (last) filename = last;
              } catch (e) { /* keep doc.title as fallback */ }
              this.dialog.success = true;
              let blob=new Blob([res.data], {type: contentType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              console.error("EXCEPTION "+JSON.stringify(res));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
    deleteDocument(doc) {
      this.del.doc = doc;
      this.del.flag = false;
      this.dialog.deleteConfirm = true;
    },
    deleteDocumentConfirmed() {
      console.log("Deleting document "+this.del.doc.documentId);
      this.dialog.deleteConfirm = false;
      this.afterSalesService.deleteDocument(this.personaltoken, this.del.doc.documentId, this.del.flag)
        .then((data) => {
          if(data.code=="200") {
            this.dialog.deleteSuccess = true;
            this.searchDocs();
          } else {
            console.error(JSON.stringify(data));
            this.dialog.deleteError = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.deleteError = true;
        });
    },
    updateDialog(doc) {
      this.edit.documentId = doc.documentId;
      this.edit.title = doc.title;
      this.edit.access = doc.access;
      this.edit.distributions = doc.distributions;
      this.dialog.editDocument = true;
    },
    documentSaved() {
      this.dialog.editDocument = false;
      this.searchDocs();
    }
  }
}
</script>